export default __webpack_public_path__ + "static/media/uniswap2.5b25e680.png";